export var SINGLE_ONLY_PRICE = 4.94;
export var WITH_PARTNER_PRICE = 6.58;
export var WITH_KIDS_PARENTS_PRICE = 8.94;
